import React from "react";

const PrimaryButton = ({ children, disabled, ...props }) => {
  return (
    <button
      {...props}
      disabled={disabled}
      style={{
        backgroundColor: disabled ? "#E0E0E0" : "#FF6500",
        color: "white",
        height: 44,
        borderRadius: 10,
        fontSize: 14,
        cursor: "pointer",
        fontWeight: 500,
        width: "100%",
        border: "none",
      }}
      type="submit"
    >
      {children}
    </button>
  );
};

export default PrimaryButton;
